import React from 'react';

const ServiceCard = ({ service, onEdit, onDelete, currentUser }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition-shadow">
      <div className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-center">
            <div className="bg-cyan-100 p-3 rounded-lg mr-4">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6 text-cyan-600" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={service.icon} />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800">{service.name}</h3>
              <p className="text-sm text-gray-500">{service.category}</p>
            </div>
          </div>
          <span className="text-cyan-600 font-medium">${service.price.toLocaleString()}</span>
        </div>

        <p className="mt-3 text-gray-600 text-sm">{service.description}</p>

        <div className="mt-4 flex justify-between items-center">
          <span className="text-sm text-gray-500">
            Duración: {service.duration} min
          </span>
          
          {currentUser.role === 'admin' && (
            <div className="flex space-x-2">
              <button 
                onClick={() => onEdit(service)}
                className="text-cyan-600 hover:text-cyan-800 text-sm"
              >
                Editar
              </button>
              <button 
                onClick={() => onDelete(service.id)}
                className="text-red-500 hover:text-red-700 text-sm"
              >
                Eliminar
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;